import React from 'react';
import { Box, Heading, Text, Button } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function NotFound() {
    const user = useSelector((state: any) => state.user.value);

    return (
        <Box textAlign="center" h={'100vh'} py={64} px={6}>
            <Heading
                display="inline-block"
                as="h2"
                size="2xl"
                bgGradient="linear(to-r, primary.100, primary.600)"
                backgroundClip="text">
                404
            </Heading>
            <Text fontSize="18px" mt={3} mb={2}>
                Page Not Found
            </Text>
            <Text color={'gray.500'} mb={6}>
                The page you're looking for does not seem to exist
            </Text>

            <Link to={
                user?.role === 'dataentry' || user?.role === 'supervisor' ?
                    '/internal/dashboard' : (
                        !user?.role ? '/login' : '/dashboard'
                    )}>
                <Button
                    variant="solid"
                >
                    Go to {!user?.role ? 'Login' : 'Dashboard'}
                </Button>
            </Link>
        </Box>
    );
}